import * as z from "zod/v4";

export const subscribeToPostscriptWebhook = {
  name: "subscribeToPostscriptWebhook" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
